import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import mapFacets from '../../../util/react/facet';

export default function CmsRichText({ value, className, facet }) {
    return (
        <div className={classnames('cms-richtext', className, mapFacets(facet, 'cms-richtext'))}
            dangerouslySetInnerHTML={{ __html: value }}/>
    );
}

CmsRichText.propTypes = {
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
    facet: PropTypes.string,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/richtext/index.js